import { RequestType } from './_types';
import { pipe } from './tools/pipe';
import { fields } from './internal/fields';
import { path } from './internal/path';
import { type } from './internal/type';
export const html = (x) => 'type' in x
    ? pipe(path('/html'), type(RequestType.Html))(x)
    : pipe(fields(x), path('/html'), type(RequestType.Html));
